<template>
  <div
    class="rows-table-wrapper">
    <v-data-table
      calculate-widths
      class="rows-table"
      disable-pagination
      fixed-header
      :headers="headers"
      hide-default-footer
      hide-default-header
      item-key="id"
      :items="positions"
      :loading-text="$t('Tenders.Loading')">
      <template slot="no-data">
        <div
          data-qa="table-no-data"
          @click="$emit('no-data-click')">
          {{ $t('Tenders.NoData') }}
        </div>
      </template>
      <template #[`header`]="{ props }">
        <thead class="v-data-table-header">
          <tr data-qa="headers">
            <th
              v-for="(headerItem, index) in props.headers"
              :key="index"
              class="text-start h9-text pre-wrap"
              :class="{'head-required': headerItem.required}"
              :data-qa="`headers-${headerItem.value}`"
              :style="`minWidth: ${headerItem.minWidth}; width: ${headerItem.width}; ${headerItem.value==='menuWithAdditionalField' && $can('use', 'availableAdditionalFields') ? 'padding: 0 8px 0 8px !important; right: 0;' : ''}`">
              <sCheckbox
                v-if="props.headers && headerItem.value==='data-table-select'"
                class="mx-auto"
                data-qa="check-all"
                :indeterminate="selected.length ? selected.length !== positions.length : false"
                :value="isSelectedAll"
                @input="selectedAll"/>
              <AdditionalFields
                v-else-if="headerItem.value==='menuWithAdditionalField' && $can('use', 'availableAdditionalFields') && isUseAdditionalFields"
                :additional_fields.sync="mutableAdditionalFields"
                binding-level="LOT"
                :entity="tender"
                small
                @changeOrder="$emit('updateAdditionalColumns', $event)"
                @update:additional_fields="$emit('updateAdditionalColumns', $event)"/>
              <span v-else>{{ headerItem.text }}</span>
            </th>
          </tr>
        </thead>
      </template>
      <template #item="{ item: row, index }">
        <EditRowTr
          ref="row"
          :additional_fields="mutableAdditionalFields"
          :change-field="changeField"
          :currency="currency"
          :delete-lot="deleteLot"
          :disabled="disabled || loading"
          :headers="headers"
          :index="index"
          :item="item"
          :new-design="newDesign"
          :positions="positions"
          :row="row"
          :rows="rows"
          :selected="selected"
          :tender="tender"
          :validate-prop-prefix="validatePropPrefix"
          @cancelSelection="el => $emit('cancelSelection', el || row)"
          @changeBidType="changeBidType"
          @check="changeCheck"
          @copyItem="el => $emit('copyItem', el || row)"
          @update:row="updateRow($event, index)"
          @update:rows="rows => $emit('update:positions', rows || positions)"/>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EditRowTr from 'components/common/elements/EditRowTr.vue'
import AdditionalFields from 'components/additional fields/AdditionalFields.vue'

import { modalMixin } from 'mixins'
import { measureMixin } from 'mixins'

export default {
  name: 'rowsTable',
  mixins: [ modalMixin, measureMixin],
  data() {
    return {
      currencies: [],
      count: 0,
      // addresses: []
    }
  },
  methods: {
    sendSelectEvent(items) {
      this.$emit('update:selected', items)
    },
    changeCheck(item) {
      const result = this.$_.cloneDeep(this.selected)
      const index = result.findIndex(i => i === item.lotNumber)
      if (index !== -1) {
        result.splice(index, 1)
      } else {
        result.push(item.lotNumber)
      }
      this.$emit('update:selected', result)
    },
    selectedAll() {
      if (this.isSelectedAll) {
        this.sendSelectEvent([])
      } else {
        this.sendSelectEvent([...this.positions.map(i => i.lotNumber || i.index)])
      }
    },
    updateRow(item, index) {
      const result = this.$_.cloneDeep(this.positions)
      result[index] = item
      this.$emit('update:positions', result)
    },
    changeBidType(value) {
      const result = this.$_.cloneDeep(this.tender)
      result.bidStepType = value
      this.$emit('update:tender', result)
    }
  },
  props: {
    tender: Object,
    item: Object,
    /**
     * позиції які будуть відображатись
     */
    positions: Array,
    headers: Array,
    deleteLot: Function,
    /**
     * валідація позицій
     */
    changeField: Function,
    /**
     * рядки з заявки
     */
    rows: Array,
    loading: Boolean,
    disabled: Boolean,
    /**
     * Префикс для свойства валидации
     */
    validatePropPrefix: {
      type: String,
      default: ''
    },
    additional_fields: {
      type: Array,
      default: () => []
    },
    newDesign: Boolean,
    selected: {
      type: Array,
      default: () => []
    },
    /**
     * Использование доп. полей
     */
    isUseAdditionalFields: {
      type: Boolean,
      default: true
    }
  },
  async created() {
    if (this.tender) {
      this.setTenderMeasurements()
      await this.$store.dispatch('setCurrencies')
        .then(res => this.currencies = res)
      if ( this.headers.some(el => el.value == 'addressId') ) {
        this.$store.dispatch('setSupplierAddress')
      }
    }
  },
  computed: {
    isSelectedAll() {
      return !!this.selected?.length && this.selected?.length === this.positions?.length
    },
    mutableAdditionalFields: {
      get() {
        return this.additional_fields
      },
      set(newValue) {
        this.$emit('update:additional_fields', newValue)
      }
    },
    currency() {
      let curr = this.currencies?.find(el => el.designation == this.tender.tenderCurrency)
      return curr?.shortTitle || this.$_getShortName(curr?.title) ||  '–'
    },
  },
  components: {
    EditRowTr,
    AdditionalFields
  }
}
</script>
<style lang="scss">
.rows-table.v-data-table {
  .custom-textarea {
    width: 100%;
  }
  .v-data-table__wrapper {
    table {
      td:not(.sForm-cell-error) {
        border-left: thin solid var(--v-main__green-base)  !important;
        &:nth-last-child(2) {
          border-right: none;
        }
      }
      thead.v-data-table-header {
        border-bottom: thin solid var(--v-main__green-base)  !important;
         tr:first-child {
          th.text-start{
            border-left: thin solid var(--v-main__green-base)  !important;
          }
        }
      }
    }
  }
  .v-data-table__wrapper {
    // max-height: calc(100vh - 150px);
    table {
      border-collapse: separate;
      td {
        *{
          word-break: break-word !important;
        }
      }
      .declaredQuantity {
        .measur {
          white-space: nowrap;
          word-break: normal !important;
        }
      }
      tbody tr td {
        &:not(.secondary__green_chosen) {
          cursor: pointer;
        }
        &, .v-input__slot {
          padding: 0!important;
        }
      }
      thead.v-data-table-header {
         tr:first-child {
          max-height: 38px;
          min-height: 38px;
          height: 38px;
          th.text-start{
            height: 38px;
            padding: 9px 20px 5px 24px !important;
            //min-width: 120px;
          }
        }
      }
    }
  }
  .v-text-field > .v-input__control > .v-input__slot {
    padding: 0;
  }
  .textarea textarea{
    line-height: 20px;
  }
  .v-input {
    &.v-input--is-focused  ~ .h7-text {
      display: none;
    }
    // &:not(.v-input--is-focused) .v-input__append-inner {
    //   display: none;
    // }
  }
}
</style>
